import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb77868"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dapp" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "vs")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Winner was not picked! ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Winner: ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!
  const _component_DappInfo = _resolveComponent("DappInfo")!
  const _component_VoteButton = _resolveComponent("VoteButton")!
  const _component_LocalStateInfo = _resolveComponent("LocalStateInfo")!
  const _component_ReclaimButton = _resolveComponent("ReclaimButton")!
  const _component_ClaimButton = _resolveComponent("ClaimButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createElementVNode("h1", {
            style: _normalizeStyle({ color: _ctx.team1Color })
          }, _toDisplayString(_ctx.dapp.Team1.Name), 5)
        ]),
        _hoisted_2,
        _createElementVNode("td", null, [
          _createElementVNode("h1", {
            style: _normalizeStyle({ color: _ctx.team2Color })
          }, _toDisplayString(_ctx.dapp.Team2.Name), 5)
        ])
      ])
    ]),
    _createVNode(_component_Bar, {
      team1Total: _ctx.dapp.Team1.Total,
      team2Total: _ctx.dapp.Team2.Total,
      team1Color: _ctx.team1Color,
      team2Color: _ctx.team2Color,
      showRatios: !_ctx.localState
    }, null, 8, ["team1Total", "team2Total", "team1Color", "team2Color", "showRatios"]),
    _createVNode(_component_DappInfo, { dapp: _ctx.dapp }, null, 8, ["dapp"]),
    (!_ctx.localState && _ctx.isVoteable)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createVNode(_component_VoteButton, {
                text: "Vote",
                color: _ctx.team1Color,
                teamName: _ctx.dapp.Team1.Name,
                dapp: _ctx.dapp
              }, null, 8, ["color", "teamName", "dapp"])
            ]),
            _hoisted_4,
            _createElementVNode("td", null, [
              _createVNode(_component_VoteButton, {
                text: "Vote",
                color: _ctx.team2Color,
                teamName: _ctx.dapp.Team2.Name,
                dapp: _ctx.dapp
              }, null, 8, ["color", "teamName", "dapp"])
            ])
          ])
        ]))
      : (_ctx.localState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_LocalStateInfo, {
              localState: _ctx.localState,
              color: _ctx.myTeamColor
            }, null, 8, ["localState", "color"]),
            (_ctx.isExpired)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createVNode(_component_ReclaimButton, { localState: _ctx.localState }, null, 8, ["localState"])
                ]))
              : (_ctx.dapp.Winner === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Winner has yet to be picked... "))
                : (!_ctx.hasClaimed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: _ctx.winningTeamColor })
                      }, _toDisplayString(_ctx.dapp.Winner), 5),
                      _hoisted_12,
                      (_ctx.isWinner)
                        ? (_openBlock(), _createBlock(_component_ClaimButton, {
                            key: 0,
                            color: _ctx.myTeamColor,
                            localState: _ctx.localState
                          }, null, 8, ["color", "localState"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}